import type { NotificationView } from '@chukua/common';
import { customerTabPath } from '../../customers/customers.paths';
import { jobTabPath } from '../../jobs/jobs.paths';

/** Where clicking a notification goes, by what raised it. Null for a type this app doesn't know, so the click only marks it read. */
export function notificationPath(notification: Pick<NotificationView, 'type' | 'entityId'>): string | null {
  if (notification.type === 'empty_return_escalation') return jobTabPath(notification.entityId, 'cargo');
  if (notification.type === 'payment_promise_due' || notification.type === 'payment_promise_broken') return customerTabPath(notification.entityId, 'promises');
  return null;
}
